import { Counter } from './Counter';
import { notifyHandledException } from '../utils/errorLogger';

type CounterTickEventArgs = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export function addProductToCart(
  productId: number,
  quantity = 1,
  lineItemProperties: Record<string, string> = {}
): Promise<Response> {
  return fetch('/cart/add.js', {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [
        {
          quantity,
          id: productId,
          properties: lineItemProperties,
        },
      ],
    }),
  });
}

export function pad(number: number | string): string {
  return `${number}`.padStart(2, '0');
}

export function initializeCountDownTimer(selector: string): void {
  const NOW = new Date();
  const TIMER_EXPIRY_TIMESTAMP =
    new Date().setMinutes(NOW.getMinutes() + 5) / 1000;

  const timer = new Counter(TIMER_EXPIRY_TIMESTAMP);
  const timerElement = document.querySelector(selector);

  const minutesElement = timerElement?.querySelector('#timer .minutes');
  const secondsElement = timerElement?.querySelector('#timer .seconds');

  timer.on('tick', ({ minutes, seconds }: CounterTickEventArgs) => {
    if (minutesElement instanceof HTMLElement) {
      minutesElement.innerHTML = pad(minutes);
    }

    if (secondsElement instanceof HTMLElement) {
      secondsElement.innerHTML = pad(seconds);
    }
  });

  timer.on('finish', () => {
    document.getElementById('cart-upsell')?.remove();
  });

  timer.start();
}

export function initInlineCartUpsellModule(): void {
  const button = document.querySelector<HTMLButtonElement>('.add-to-cart');

  if (!button) {
    return;
  }

  button.addEventListener('click', () => {
    const productId = parseInt(button.dataset.product || '');
    button.setAttribute('disabled', 'disabled');
    button.classList.add('offer-cta__button--busy');
    button.innerText = '';
    addProductToCart(productId)
      .then(() => {
        window.location.reload();
      })
      .catch(notifyHandledException);
  });

  initializeCountDownTimer('#timer');
}
